import { create } from 'zustand';

export interface commonStoreType {
    prevPath: string;
    currentPath: string;
    setPaths: (prev: string, current: string) => void;
}

export const useCommonStore = create<commonStoreType>((set) => ({
    prevPath: '',
    currentPath: '',
    setPaths: (prev, current) => set({ prevPath: prev, currentPath: current }),
}));
